import React, { useEffect, useState, useMemo } from 'react';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import { getAllMake } from '../../../../Core/Services/InternalUser/makeService';
import { AddButton, EditButton, BreadCrumbs, DataGrid } from '../../../../Core/Controls';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import ReactDOM from 'react-dom';
import '../../../commonStyle.scss';
import PartsAddUpdate from './PartsAddUpdate';

const makeScreenStyle = {
    gridEditButton: { textAlign: 'center' }
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Vehicles', active: true },
    { name: 'Parts', active: true }
];

// const basecolumns = [
//     { key: 'action', name: 'Action', width: '5%' },
//     { key: 'makeDescription', name: 'Description' },
//     { key: 'makeLogo', name: 'Logo', formatter: makeLogoRender, width: '25%', filterable: 'no' },
//     { key: 'makeActive', name: 'Is Active ?', formatter: (e) => (e.row.makeActive ? 'Yes' : 'No'), width: '20%' }
// ];

const basecolumns = [
    { key: 'action', name: `Action`, width: 70, filterable: 'no' },
    { key: 'partNumber', sortable: false, name: `Part Number`, width: 120 },
    { key: 'description', sortable: false, name: `Part Description` },
    { key: 'quantityOnPOrder', sortable: false, name: `Quantity`, width: 120 },
    { key: 'sellingPrice', sortable: false, name: `Price`, width: 120 },
    { key: 'unitOfStock', sortable: false, name: `Unit`, width: 120 },
    { key: 'binLocation', sortable: false, name: `Location`, width: 120 },
    { key: 'isActive', sortable: false, name: `Is Active`, width: 120 }
];

const PartsListScreen = (props) => {
    const [state, setState] = useState({
        showModal: false,
        uservalue: null,
        makeList: [],
        showLoader: true
    });

    useEffect(async () => {
        pullMakeData();
    }, []);

    const pullMakeData = async () => {
        setState((state) => ({
            ...state,
            isReload: new Date()
        }));
    };

    const actionButton = (data, row) => {
        return (
            <div className="make-btn-update" style={makeScreenStyle.gridEditButton}>
                <EditButton onClick={() => handleEdit(row)} toolTipTitle="Edit Part" />
            </div>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = actionButton;
        }
        return tempCols;
    }, []);

    const title = state.userId ? 'Update Part' : 'Add Part';

    const handleEdit = (val) => {
        setState((st) => ({
            ...st,
            showModal: true,
            partID: val?.partID
        }));
    };

    const handleClose = (res) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showModal = false;
            if (res) {
                newSt.isReload = new Date();
            }
            return newSt;
        });
    };

    return (
        <div className="screen">
            <div sm={12}>
                <BreadCrumbs crumbs={crumbs} />
            </div>
            <GijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'AdminParts/Parts_List'}
                btnTitle="Add Part"
                onBtnClick={() => handleEdit(null)}
                isReload={state.isReload}
            />

            {state.showModal ? (
                <DialogComp
                    title={`${state.partID ? `Update` : `Add`} Parts`}
                    maxWidth="sm"
                    onClose={() =>
                        setState((st) => ({
                            ...st,
                            showModal: false
                        }))
                    }
                    fullWidth
                >
                    <PartsAddUpdate onClose={() => handleClose(true)} partID={state.partID} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default PartsListScreen;
